import { ensureString, toNumber } from '../../../helper/lodash_replacements';
// npm mysql outputs DECIMAL as string!!
class SerializrType_decimal {
    fragtionDigits;
    constructor(fragtionDigits) {
        this.fragtionDigits = fragtionDigits;
    }
    serializer({ value: valueAsNumber }) {
        return ensureString(toNumber(valueAsNumber).toFixed(this.fragtionDigits));
    }
    deserializer({ json: valueAsString }) {
        return toNumber(valueAsString);
    }
}
const map = new Map();
export function decimal(fragtionDigits) {
    if (map.has(fragtionDigits)) {
        return map.get(fragtionDigits);
    }
    const instance = new SerializrType_decimal(fragtionDigits);
    map.set(fragtionDigits, instance);
    return instance;
}
/*
https://github.com/mysqljs/mysql
Type casting

For your convenience, this driver will cast mysql types into native JavaScript types by default. The following mappings exist:

Number

TINYINT
SMALLINT
INT
MEDIUMINT
YEAR
FLOAT
DOUBLE
Date

TIMESTAMP
DATE
DATETIME
Buffer

TINYBLOB
MEDIUMBLOB
LONGBLOB
BLOB
BINARY
VARBINARY
BIT (last byte will be filled with 0 bits as necessary)
String

Note text in the binary character set is returned as Buffer, rather than a string.

CHAR
VARCHAR
TINYTEXT
MEDIUMTEXT
LONGTEXT
TEXT
ENUM
SET
DECIMAL (may exceed float precision)
BIGINT (may exceed float precision)
TIME (could be mapped to Date, but what date would be set?)
GEOMETRY (never used those, get in touch if you do)

 */
